import { render, staticRenderFns } from "./FieldsConfirmationModal.vue?vue&type=template&id=4310985a&scoped=true&"
import script from "./FieldsConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./FieldsConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./FieldsConfirmationModal.vue?vue&type=style&index=0&id=4310985a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4310985a",
  null
  
)

export default component.exports